import Glide from '@glidejs/glide';
import BaseModule from '../../../javascripts/helpers/baseModule';

export default class Quote extends BaseModule {
  constructor(element) {
    super(element, 'quote', [{ id: 'glide', selector: 'glide' }]);
  }

  init() {
    if (this.elements.glide.dataset.slides > 1) {
      new Glide(this.elements.glide).mount();
    }
  }
}
